import {slideUp, slideDown, slideToggle} from "./slide";
export default class Menu{
    constructor(){
        this.desktopDropdownBtns = document.querySelectorAll('.header-desktop .nav > li.menu-item-has-children');
        if (this.desktopDropdownBtns){
            this.desktopDropdowns(this.desktopDropdownBtns);
        }

        this.desktopDropdownBtnsDeep = document.querySelectorAll('.header-desktop .nav > li.menu-item-has-children > ul > li.menu-item-has-children');
        if (this.desktopDropdownBtnsDeep){
            this.desktopDropdowns(this.desktopDropdownBtnsDeep);
        }

        this.mobileDropdownBtns = document.querySelectorAll('.header-mobile .nav > li.menu-item-has-children > a');
        if (this.mobileDropdownBtns){
            this.animating = false;
            this.openedDropdown;
            this.mobileDropdowns(this.mobileDropdownBtns);
        }

        // this.mobileDropdownBtnsDeep = document.querySelectorAll('.header-mobile .nav > li.menu-item-has-children > ul > li.menu-item-has-children > a');
        // if (this.mobileDropdownBtnsDeep){
        //     this.animatingDeep = false;
        //     this.openedDropdownDeep;
        //     this.mobileDropdownsDeep(this.mobileDropdownBtnsDeep);
        // }


        this.menuToggleBtn = document.querySelector('.nav__toggle');
        this.headerMobile = document.querySelector('.header-mobile');
        this.headerMobileContent = this.headerMobile.querySelector('.header__content');

        this.toggling = false;

       // this.mobileSearchForm = document.querySelector('.header-mobile .search-form');

        if (this.menuToggleBtn){
            this.toggleMenu();
        }
    }

    toggleMenu(){
        this.menuToggleBtn.addEventListener('click', (e) => {
            if (!this.toggling){
                this.toggling = true;
                // if (this.mobileSearchForm.classList.contains('active')){
                //     slideToggle(this.mobileSearchForm);
                // }
                this.headerMobile.classList.toggle('active');
                document.body.classList.toggle('menu-opened');
                slideToggle(this.headerMobileContent, 500, () => { this.toggling = false });
            }
        });
    }

    mobileDropdowns(items) {

        items.forEach(btn => {
            let item = btn.parentNode;
            btn.addEventListener('click', (e) => {
                e.preventDefault();
            });

            const dropdown = item.querySelector('.sub-menu');
            item.addEventListener('click', () => {
                if (!this.animating){
                    this.animating = true;
                    if (this.openedDropdown){
                        this.openedDropdown.parent.classList.remove('active');
                        slideUp(this.openedDropdown.dropdown, 500, () => { this.animating = false });
                        if (this.openedDropdown.parent == item){
                            this.openedDropdown = null;
                            return;
                        }
                        this.openedDropdown = null;
                    }
                    item.classList.add('active');
                    slideDown(dropdown, 500, () => { this.animating = false });

                    this.openedDropdown = {
                        'parent' : item,
                        'dropdown' : dropdown,
                    };
                }
            });
        });
    }

    mobileDropdownsDeep(items) {

        items.forEach(btn => {
            let item = btn.parentNode;
            btn.addEventListener('click', (e) => {
                e.preventDefault();
            });

            const dropdownDeep = item.querySelector('.sub-menu');
            item.addEventListener('click', () => {
                if (!this.animatingDeep){
                    this.animatingDeep = true;
                    if (this.openedDropdownDeep){
                        this.openedDropdownDeep.parent.classList.remove('active');
                        slideUp(this.openedDropdownDeep.dropdownDeep, 500, () => { this.animatingDeep = false });
                        if (this.openedDropdownDeep.parent == item){
                            this.openedDropdownDeep = null;
                            return;
                        }
                        this.openedDropdownDeep = null;
                    }
                    item.classList.add('active');
                    slideDown(dropdownDeep, 500, () => { this.animatingDeep = false });

                    this.openedDropdownDeep = {
                        'parent' : item,
                        'dropdownDeep' : dropdownDeep,
                    };
                }
            });
        });
    }

    desktopDropdowns(items) {
        let closeTimeout;
        let openTimeout;
        items.forEach(item => {

            let btn = item.querySelector(':scope > a');
            btn.addEventListener('click', (e) => {
                e.preventDefault();
            });

            item.addEventListener('mouseenter', () => {
                clearTimeout(closeTimeout);
                openTimeout = setTimeout(() =>{
                    items.forEach(tempItem =>{
                        tempItem.classList.remove('active');
                    });
                    item.classList.add('active');
                }, 200);
            });
            item.addEventListener('mouseleave', () => {
                clearTimeout(openTimeout);
                closeTimeout = setTimeout(() =>{
                    item.classList.remove('active');
                }, 800);
            });
        });
    }
}